export default __webpack_public_path__ + "static/whatsapp-widget-d6175c68f8039bbcd3ebae85ec0957d6.png";